import vehicleMaintenanceApplyDlg from './vehicleMaintenanceApplyDlg'        // 车辆维保申请申请
import vehicleHandoverApplyDlg from './vehicleHandoverApplyDlg'        // 车辆交换

const administrativeMan = {
  namespaced: true,
  modules: {
    vehicleMaintenanceApplyDlg,
    vehicleHandoverApplyDlg
  }
}

export default administrativeMan
